import createOrmSelector from 'redux/utils/createOrmSelector';

export default createOrmSelector(
  (session) => {
    const { Gene } = session;

    return Gene.all().toRefArray();
  },
);
